// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"3315fdba","211":"b4d8af26","403":"469939bb","409":"5d43e387"}[chunkId] + ".chunk.js";
};